"use strict";

($dt => {
	
	$dt.TopicGrid = {
		Constants: {
			TOPIC_TYPES: $dt.topic_types,
			QUESTION_TYPES: $dt.class_question_types,
			DEBOUNCE_DEFAULT: 300,
			STRIPE: {
				address: true
			},
			anim_delay: 251, // needs to be in sync with CSS animations
			min_attendees: 15,
			additional_notes_default_text: $dt.additional_notes_default_text
		},
		Functions: {},
		ScreenFunctions: {},
		SelectAttendees: {},
	};

})(window.d3_wp_themejs);
